import React from 'react';
import { hasNoValue } from '../components/inputs/inputHelpers';

export const printMoney = (money: number) => {
  try {
    if (hasNoValue(money)) return '';
    return money ? (
      <span>
        UGX&nbsp;
        {new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(
          money,
        )}
      </span>
    ) : (
      ''
    );
  } catch (e) {
    return '';
  }
};

export const printNumber = (number: any) => {
  try {
    if (hasNoValue(number)) return '';
    return number ? new Intl.NumberFormat().format(number) : '';
  } catch (e) {
    return '';
  }
};

export const printDecimal = (number: number) => {
  try {
    if (hasNoValue(number)) return '';
    return number
      ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(
          number,
        )
      : '';
  } catch (e) {
    return '';
  }
};

export const printInteger = (number: number) => {
  try {
    if (hasNoValue(number)) return '';
    return number
      ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(
          number,
        )
      : '';
  } catch (e) {
    return '';
  }
};

// Fixed approximate conversion — this app has no live FX feed, so update
// this constant by hand if the rate drifts noticeably.
export const APPROX_UGX_PER_USD = 3700;

export const formatCompact = (n: number): string => {
  const abs = Math.abs(n);
  const sign = n < 0 ? '−' : '';
  if (abs >= 1_000_000_000) {
    const v = abs / 1_000_000_000;
    return `${sign}${v % 1 === 0 ? v.toFixed(0) : v.toFixed(1)}B`;
  }
  if (abs >= 1_000_000) {
    const v = abs / 1_000_000;
    return `${sign}${v % 1 === 0 ? v.toFixed(0) : v.toFixed(1)}M`;
  }
  if (abs >= 1_000) {
    const v = abs / 1_000;
    return `${sign}${v % 1 === 0 ? v.toFixed(0) : v.toFixed(1)}K`;
  }
  return `${sign}${Math.round(abs)}`;
};
